export const objectToQuery = (
  object: Record<string, string | number | Array<string>>,
) => {
  const url = new URL(location.href);
  Object.entries(object).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      url.searchParams.delete(`q[${key}][]`);
      value.forEach((v) => url.searchParams.append(`q[${key}][]`, v));
    } else {
      url.searchParams.set(`q[${key}]`, String(value));
    }
  })
  return url;
};
